import { render, staticRenderFns } from "./officine_list.vue?vue&type=template&id=10ead633&"
import script from "./officine_list.vue?vue&type=script&lang=js&"
export * from "./officine_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports